var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueryMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m2.2501 1.59998h-.65v.65 9.75002.65h.65 1.6v3.1.65h.65 11.25.65v-.65-9.75002-.65h-.65-2.35v-3.1-.65h-.65zm11.15 5.05v5.35002.65h-.65-7.6v2.45h9.95v-8.45002zm-10.5 4.70002v-8.45002h9.2v8.45002z",
    fill: "#4c5664",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4C5664",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.375 8.625-1.5-1.5 1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.625 5.625 1.5 1.5-1.5 1.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryMain);
export default __webpack_public_path__ + "static/media/query-main.251e30cb352096627ec44bde240a893d.svg";
export { ForwardRef as ReactComponent };